'use client';

import { colors } from '../Utils/constants.js';

var DEFAULT_COLORS = [
    colors.cardShadow,
    colors.darkBlueColor,
    colors.infoColor,
    colors.primaryColor,
    '#4083FF',
    colors.buttonColor,
    colors.dangerColor,
    colors.highlightColor
];
// Max default radius in pixel
var DEFAULT_MAX_RADIUS = 50;
// Default minus radius in pixel
var DEFAULT_MINUS_RADIUS = 3;
var DEFAULT_OPTIONS = {
    width: 260,
    height: 260,
    isShowLegend: true,
    isFocusHover: true,
    isFocusHoverOnBottomLegend: false,
    isUsingRadiusRange: true,
    isDonutChart: true,
    highlightText: 'You are here',
    pieStrokeWidth: 1,
    horizontalLegend: false,
    highlightColor: colors.successColor,
    showHighlightTextOnLegend: false
};

export { DEFAULT_COLORS, DEFAULT_MAX_RADIUS, DEFAULT_MINUS_RADIUS, DEFAULT_OPTIONS };
//# sourceMappingURL=constants.js.map
